import React from "react";
import BlogTwo from "../component/BlogTwo";

function BlogTwoContainer() {
  return <BlogTwo />;
}
export default BlogTwoContainer;
